import { Type } from 'class-transformer';
import { IsDefined, IsOptional, ValidateNested } from 'class-validator';
import { EntityStateDto } from '../../@base';
import { BaseDto } from '../../@base/base.dto';
import { ContactInfosDto, PostalAddressDto } from '../../administrative';
import { UserRoleRepresentationDto } from '../../keycloak';
import { AgentProfileId, OwnerProfileId, UserId } from '../../types';
import { UserIdentityPopulateAvatarDto } from './populate/user-identity-populate-avatar.dto';
import { UserAdminMetadataDto } from './user-metadata.dto';
import { UserSettingsDto } from './user-settings.dto';
import { UserSubscriptionDto } from './user-subscription.dto';

export class UserForAdminDto extends BaseDto<UserId> {
  @ValidateNested()
  @Type(() => UserIdentityPopulateAvatarDto)
  identity!: UserIdentityPopulateAvatarDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => PostalAddressDto)
  address?: PostalAddressDto;

  @ValidateNested()
  @Type(() => ContactInfosDto)
  @IsDefined()
  contactInfos!: ContactInfosDto;

  @ValidateNested()
  @Type(() => UserSettingsDto)
  settings!: UserSettingsDto;

  @ValidateNested()
  @Type(() => UserAdminMetadataDto)
  @IsDefined()
  metadata!: UserAdminMetadataDto;

  @ValidateNested()
  @Type(() => UserRoleRepresentationDto)
  @IsDefined()
  roles!: UserRoleRepresentationDto[];

  @ValidateNested()
  @Type(() => EntityStateDto)
  state!: EntityStateDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => UserSubscriptionDto)
  subscription?: UserSubscriptionDto;

  @IsOptional()
  profiles?: {
    agent?: AgentProfileId;
    owner?: OwnerProfileId;
  };
}
